import React, {useRef, useState} from "react";
import {useIntl} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router";
import {Link as RouterLink} from "react-router-dom";

import {useSnackbar} from "notistack";

import {
  Avatar,
  Button,
  ButtonBase,
  Hidden,
  Menu,
  MenuItem,
  SvgIcon,
  Typography,
  makeStyles
} from "@material-ui/core";

import {logout} from "src/actions/accountActions";

import authService from "src/services/authService";

const useStyles = makeStyles((theme) => ({
  avatar: {
    height: 35,
    width: 35,
    fontSize: 15,
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.background.default
  },
  popover: {
    width: 180
  }
}));

function LogoutIcon() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#000000"
      >
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
      </svg>
    </SvgIcon>
  );
}

function ProfileIcon() {
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 0 24 24"
        width="24px"
        fill="#000000"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1s-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.22 0 .41.1.55.25.12.13.2.31.2.5 0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-.19.08-.37.2-.5.14-.15.33-.25.55-.25zM19 19H5V5h14v14zM12 6c-1.65 0-3 1.35-3 3s1.35 3 3 3 3-1.35 3-3-1.35-3-3-3zm0 4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-6 6.47V18h12v-1.53c0-2.5-3.97-3.58-6-3.58s-6 1.07-6 3.58zM8.31 16c.69-.56 2.38-1.12 3.69-1.12s3.01.56 3.69 1.12H8.31z" />
      </svg>
    </SvgIcon>
  );
}

function Account() {
  const classes = useStyles();
  const {formatMessage} = useIntl();
  const history = useHistory();
  const ref = useRef(null);
  const dispatch = useDispatch();
  const account = useSelector((state) => state.account);
  const {enqueueSnackbar} = useSnackbar();
  const [isOpen, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLogout = async () => {
    try {
      handleClose();
      await authService.writeLogWhenLogout();
      await dispatch(logout());
      await dispatch({type: "RESET_STATE_WHEN_LOGOUT"});
      history.push("/");
    } catch (error) {
      console.log(error);
      enqueueSnackbar(
        formatMessage({
          id: "dashboardLayout-topBar-account-McpdU",
          defaultMessage: "Unable to logout",
          description: ""
        }),
        {
          variant: "error"
        }
      );
    }
  };

  const getDisplayName = () => {
    let result;
    if (account.user.avatar) {
      result = account.user.avatar;
    } else if (account.user.first_name && account.user.last_name) {
      result = `${account.user.first_name
        .substring(0, 1)
        .toUpperCase()}${account.user.last_name.substring(0, 1).toUpperCase()}`;
    } else {
      result = "AD";
    }
    return result;
  };

  return (
    <>
      <Button
        component={ButtonBase}
        onClick={handleOpen}
        ref={ref}
        style={{color: "white"}}
      >
        <Avatar
          alt={account.user.avatar ? account.user.avatar : "ADMIN"}
          className={classes.avatar}
          src={account.user.avatar ? account.user.avatar : "/broken-image.jpg"}
        >
          {getDisplayName()}
        </Avatar>
        <Hidden smDown>
          <Typography variant="h6" color="inherit" style={{fontSize: 15}}>
            {`${account.user.first_name || ""} ${account.user.last_name || ""}`}
          </Typography>
        </Hidden>
      </Button>
      <Menu
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center"
        }}
        keepMounted
        PaperProps={{className: classes.popover}}
        getContentAnchorEl={null}
        anchorEl={ref.current}
        open={isOpen}
      >
        {/* <MenuItem
          component={RouterLink}
          to="/app/social/profile"
        >
          Profile
        </MenuItem> */}
        <MenuItem onClick={handleClose} component={RouterLink} to="/app/account">
          <ProfileIcon />
          &nbsp;{" "}
          {formatMessage({
            id: "dashboardLayout-topBar-account-UcDmS",
            defaultMessage: "Account",
            description: ""
          })}
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <LogoutIcon />
          &nbsp;{" "}
          {formatMessage({
            id: "dashboardLayout-topBar-account-ghrnw",
            defaultMessage: "Logout",
            description: ""
          })}
        </MenuItem>
      </Menu>
    </>
  );
}

export default Account;
